var map = {
	"./cn/长城书院/pc.svg": "2Gmv",
	"./en/长城书院/pc.svg": "cUg0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XEtr";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/长城书院\/pc\.svg$
// module id = XEtr
// module chunks = 16